import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Tu mamá es tacaña
        </p>

          Learn React
      </header>
    </div>
  );
}

export default App;
